import { useEffect, useState } from "react";
import { Box, Text, Flex, Avatar, Icon, Button, Center, Spinner, } from "@chakra-ui/react";
import { CalendarIcon } from "@chakra-ui/icons";
import "react-calendar/dist/Calendar.css";

import MyDiv from "./workAnniversaryCard.style";
import DummyPerson from "../../../../assets/images/DummyPerson.svg";
import { CustomToast } from "../../../../components";
import { useFetch } from "../../../../hooks/useFetch";
import { WorkAnniversaryPerson } from "./model";
import { showDate } from "../../../../utilities/helper";

const getWeekRange = (date: Date) => {
  const day = date.getDay();
  const diffToMonday = (day + 6) % 7;

  const start = new Date(date);
  start.setDate(date.getDate() - diffToMonday);

  const end = new Date(start);
  end.setDate(start.getDate() + 6);

  return { start, end };
};

const formatWeekRange = (date: Date) => {
  const { start, end } = getWeekRange(date);

  const formatter = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
  });

  return `Week: ${formatter.format(start)} – ${formatter.format(
    end
  )}, ${start.getFullYear()}`;
};

interface Props {
  branch?: number[];
}

const WorkAnniversaryCard = ({ branch }: Props) => {
  const [selectedDate] = useState(new Date());
  const [employeeId, setEmployeeId] = useState<number | null>(null);
  const [workData, setWorkData] = useState<WorkAnniversaryPerson[]>([]);

  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);

  useEffect(() => {
    const loginDataString = sessionStorage.getItem("loginData");

    if (loginDataString) {
      const loginData = JSON.parse(loginDataString);
      setEmployeeId(loginData.employeeId);
    }
  }, []);

  const fetchWorkAnniversaries = async () => {
    try {
      const params = new URLSearchParams();

      if (branch && branch.length > 0) {
        branch.forEach((b) => params.append("branch", b.toString()));
      } else {
        params.append("branch", "0");
      }

      if (employeeId) {
        params.append("id", employeeId.toString());
      }

      const queryString = params.toString();

      const data = await fetchApi<WorkAnniversaryPerson[]>("Dashboard/WorkAnniversaries", "GET", null, queryString);

      if (data) {
        setWorkData(data);
      } else {
        setWorkData([]);
      }
    } catch (error) {
      console.error("Error fetching work anniversaries:", error);
    }
  };

  useEffect(() => {
    fetchWorkAnniversaries();
  }, [employeeId, branch]);

  return (
    <MyDiv>
      <Box pl={4} pr={4} className="card-wrapper common_bg" rounded="xl">
        <Flex justify="space-between" align="center" pt={3} pl={1} mb={1}>
          <Text className="font-poppins text_medium text_lg">
            Work Anniversaries
          </Text>

          <Button leftIcon={<Icon as={CalendarIcon} />} className="font-poppins text_regular text_sm" size="sm" bg="white" border="1px solid #E2E8F0"
            borderRadius="md" _hover={{ bg: "white" }} _active={{ bg: "white" }} _focus={{ boxShadow: "none" }} cursor="default" isDisabled
          >
            {formatWeekRange(selectedDate)}
          </Button>
        </Flex>

        <Box className="birthday-list">
          <Box position="relative" minH="300px">
            {loading ? (
              <Center position="absolute" top={0} left={0} right={0} bottom={0} >
                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
              </Center>
            ) : (
              <>
                {workData.length > 0 ? (
                  workData.map((person, index) => (
                    <Box className="birthday-row" key={index} mb={2}>
                      <Flex align="center" justify="space-between">
                        <Flex align="center">
                          <Avatar name={person.name} src={person.image || DummyPerson} size="sm" mr={3} />

                          <Box>
                            <Text className="font-poppins text_medium text_sm">
                              {person.name}
                            </Text>

                            <Text fontSize="9px" color="gray.500">
                              {person.position}
                            </Text>

                            {/* <Text fontSize="9px" color="gray.500">
                              {person.department} • {person.branch}
                            </Text> */}

                            {/* <Text fontSize="9px" color="gray.500" noOfLines={1}>
                              {person.company}
                            </Text> */}
                          </Box>
                        </Flex>

                        <Text className="font-poppins text_medium" fontSize="9px" color="green.500" >
                          {showDate(person.date)}
                        </Text>
                      </Flex>
                    </Box>
                  ))
                ) : (
                  <Flex justify="center" align="center" height="200px" color="gray.500" >
                    <Text className="font-poppins text_regular text_md">
                      No Work Anniversaries this Week.
                    </Text>
                  </Flex>
                )}
              </>
            )}
          </Box>
        </Box>
      </Box>
    </MyDiv>
  );
};

export default WorkAnniversaryCard;